/**
 * The brand mark. Its width is what the ways are indented by, so in the
 * sidebar it comes to sit exactly over the row icons beneath it.
 */
export function PaxGlobe() {
  return (
    <span className="relative flex size-7 items-center justify-center overflow-hidden rounded-full border bg-white dark:bg-zinc-900">
      <img
        src="/images/pax-globe-135x135.png"
        width={18}
        height={18}
        alt=""
        className="object-contain dark:hidden"
      />
      <img
        src="/images/pax-globe-400x400-light.png"
        width={18}
        height={18}
        alt=""
        className="hidden object-contain dark:block"
      />
    </span>
  );
}
